import { __rest } from "tslib";
import React from 'react';
import "./ProductVideoContainer.css";
var styles = { "touchAdjustments": "eb94c2" };
import ProductVideo from '../../../ProductVideo';
import ProductLink from '../ProductLink';
const ProductVideoContainer = (_a) => {
    var { videoLabels, videoOptions, videoFallbackImage, videoId, title, articleCode } = _a, props = __rest(_a, ["videoLabels", "videoOptions", "videoFallbackImage", "videoId", "title", "articleCode"]);
    if (!videoFallbackImage || !videoId || !videoOptions || !videoLabels)
        return null;
    return (React.createElement(ProductLink, Object.assign({ className: styles.touchAdjustments }, props),
        React.createElement(ProductVideo, { posterImage: videoFallbackImage, name: title, videoId: `ref:${videoId}`, description: title, labels: videoLabels, options: videoOptions, shouldShowPlayVideoButton: false, key: `video-${articleCode}`, autoplay: true })));
};
export default ProductVideoContainer;
//# sourceMappingURL=ProductVideoContainer.js.map